/** Present remaining active-play seconds from canonical effect expiry times.
 * Pausing cannot consume an effect; an exhausted shield is never advertised. */
export function bobEffectText(state) {
  const boost = Math.max(0, Math.ceil((state.effects.boostUntil - state.elapsed) / 1000));
  const shield =
    state.effects.shieldCharges > 0
      ? Math.max(0, Math.ceil((state.effects.shieldUntil - state.elapsed) / 1000))
      : 0;
  return [boost ? `Boost ${boost}s` : '', shield ? `Shield ${shield}s` : '']
    .filter(Boolean)
    .join(' · ');
}

/** Present actual domain events, never predicted points. Higher-priority pickup
 * guidance survives a simultaneous movement award; duration is wall-clock ms. */
export function bobFeedback(event) {
  if (event.type === 'arcade' && !(event.points > 0)) return null;
  if (event.type === 'arcade')
    return {
      priority: 6,
      duration: 1500,
      text: `${event.label} · ×${event.multiplier} +${event.points}`,
      announcement: event.tierChanged
        ? `${event.label.toLowerCase()}, ${event.chain} actions, ${event.points} chain bonus points.`
        : null,
    };
  if (event.type === 'chain-reaction')
    return {
      priority: 5,
      duration: 1400,
      text: `CHAIN REACTION! · ${event.count} goodies`,
      announcement: `Chain reaction collected ${event.count} nearby goodies.`,
    };
  if (['food', 'speed'].includes(event.type)) return null;
  if (['spring', 'crate', 'bonus-route'].includes(event.type))
    return {
      priority: event.type === 'bonus-route' ? 5 : 3,
      duration: 1400,
      text:
        event.type === 'spring'
          ? 'SPRING! · follow the crates'
          : `${event.type === 'bonus-route' ? 'BONUS ROUTE!' : 'SMASH!'} +${event.points}`,
      announcement:
        event.type === 'spring'
          ? 'Spring launch. Steer through the aerial crates.'
          : `${event.type === 'bonus-route' ? 'Bonus route cleared' : 'Crate smashed'}, ${event.points} points.`,
    };
  if (event.type === 'stumble')
    return {
      priority: 9,
      duration: 1300,
      text: event.lostGoodies ? `GOODIES LOST · −${event.lostGoodies}` : 'NO GOODIES · RUN ENDED',
      announcement: event.lostGoodies
        ? `Bob dropped ${event.lostGoodies} goodie points. Other points are safe. Collect more goodies before the next hit.`
        : 'Bob stumbled with no goodies. The run has ended.',
    };
  if (event.type === 'powerup' || event.type === 'shield') {
    return {
      priority: 3,
      duration: 1400,
      text:
        event.type === 'shield'
          ? 'Shield saved Bob!'
          : event.kind === 'boost'
            ? 'TURBO! · 6 seconds'
            : 'SHIELD ON · one hit protected',
      announcement:
        event.type === 'shield'
          ? 'Shield used. Bob is safe; steer clear of the next obstacle.'
          : event.kind === 'boost'
            ? 'Speed boost collected. Accelerating now, with extra speed for six seconds.'
            : 'Shield collected. Your next hazard hit or ground stumble is protected for twelve seconds.',
    };
  }
  if (event.type === 'timing')
    return {
      priority: 2,
      duration: 1200,
      text: `${event.grade}${event.points ? ` +${event.points}` : ''}`,
      announcement: `${event.grade.toLowerCase()} bounce${event.points ? `, ${event.points} points` : ''}.`,
    };
  if (!(event.points > 0)) return null;
  const label =
    event.type === 'combo'
      ? 'DELICIOUS! '
      : event.type === 'speed'
        ? 'SPEED '
        : event.type === 'checkpoint'
          ? 'CHECKPOINT '
          : '';
  return {
    priority: 1,
    duration: 1000,
    text: `${label}+${event.points}`,
    announcement: null,
  };
}
